import { isDemoMode } from "./demoEnviornment";

export const incrementCustomerCount = (type) => {
    if (!isDemoMode()) return 0; // only count in demo mode
    const key = type
    const current = parseInt(localStorage.getItem(key) || "0");
    const newCount = current + 1;
    localStorage.setItem(key, newCount);
    return newCount;
};

export const shouldShowModal = (type) => {
    if (!isDemoMode()) return false; // never show in production
    const key = type
    const count = parseInt(localStorage.getItem(key) || "0");
    // show modal on 1st, 4th, 7th, 10th... creation
    return count === 1 || count % 3 === 1;
};
